export default {
    name: 'digsMixin',
    computed: {
        isDigsSubscribed() {
            if (this.glb.claimedHomes && this.glb.claimedHomes.length) {
                return this.glb.claimedHomes.map((v) => v.propertyId).indexOf(this.dpp.propertyId) !== -1;
            }
            return false;
        },
        goToDashboard() {
            if (this.isDigsSubscribed) {
                return this.glb.appUrl + 'homeowner/';
            }
        },
    },
    methods: {
        openDig() {
            this.$eventBus.$emit('eventbus-pop-dig');
        },
    },
};